import { ButtonHTMLAttributes } from 'react'

import Button from '@/components/base/button'
import Spinner from '@/components/base/spinner'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type LoadMoreProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fetching?: boolean
}

const LoadMoreButton = ({ fetching, ...props }: LoadMoreProps) => {
  const { strings } = useStore()

  return (
    <Button
      variant="primary"
      endIcon={fetching ? <Spinner variant="small" /> : <></>}
      className={cn(['dark flex w-full justify-center', { 'pointer-events-none': fetching }])}
      {...props}
    >
      <Typography mask>{strings?.labels.load_more}</Typography>
    </Button>
  )
}

export default LoadMoreButton
